import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('foquz-modal-header', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      let $element = $(element);
      $element.addClass('modal-header');

      return new ViewModel(params);
    },
  },
  template: html,
});
